import * as React from 'react'

export const HeadingFourIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M23.5175 18.2585H22.0995V20.6997H19.6664V18.2585H14.639V16.5264L19.8033 8.9209H22.0995V16.325H23.5175V18.2585ZM19.6664 16.325V14.3269C19.6664 13.9939 19.6798 13.5105 19.7067 12.8767C19.7335 12.2429 19.755 11.875 19.7711 11.7729H19.7067C19.5079 12.2134 19.2689 12.6431 18.9896 13.062L16.8304 16.325H19.6664Z'
        fill='currentColor'
      />
      <path
        d='M3.85706 2.69971V9.44971H9.85706V2.69971H12.8571V20.6997H9.85706V12.8247H3.85706V20.6997H0.857056V2.69971H3.85706Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingFourIcon.displayName = 'HeadingFourIcon'
